module.exports = __webpack_public_path__ + "img/featur_2.7e40d0c8.jpg";